import { createSelector } from 'reselect';
import getSelectedOffer, { $getSelectedOffer } from './getSelectedOffer';
import getOrderTotals, { $getOrderTotals } from './getOrderTotals';
import getStagedPurchaseCount, {
  $getStagedPurchaseCount,
} from './getStagedPurchaseCount';

import { getChoiceOrderingMethod } from './config';
import { OFFER_TYPE } from '../constants/offerType';
import getStagedPurchases, { $getStagedPurchases } from './getStagedPurchases';
import { bogoValidation } from '../utils/ordering/bogoCoupon';
import validateOffersForItem from '../utils/ordering/validateOffersForItem';

const get = (
  selectedOffer: Offer | undefined,
  orderTotals: OrderTotals | undefined,
  stagedPurchaseCount: number,
  purchasedItems: any,
  choiceOrderingMethod: any,
): boolean | undefined => {
  if (!selectedOffer) return undefined;

  if (!orderTotals || !stagedPurchaseCount || stagedPurchaseCount < 1) {
    return false;
  }
  const offerType = selectedOffer.type;

  if (
    offerType === OFFER_TYPE.PERCENTAGE_OFF_ITEM_AND_INGREDIENTS ||
    offerType === OFFER_TYPE.PERCENTAGE_OFF_ITEM_OR_INGREDIENTS ||
    offerType === OFFER_TYPE.AMOUNT_OFF_ITEM ||
    offerType === OFFER_TYPE.PRICE_OVERRIDE_ITEM_OR_INGREDIENT
  ) {
    return validateOffersForItem(purchasedItems, selectedOffer);
  }
  if (
    offerType === OFFER_TYPE.AMOUNT_OFF_BOGO ||
    offerType === OFFER_TYPE.PERCENTAGE_OFF_BOGO
  ) {
    //bogo coupon validation
    return bogoValidation(selectedOffer, purchasedItems, choiceOrderingMethod);
  }

  return true;
};

export default createSelector(
  [
    getSelectedOffer,
    getOrderTotals,
    getStagedPurchaseCount,
    getStagedPurchases,
    getChoiceOrderingMethod,
  ],
  get,
);

export const $getSelectedOfferHasEffect = createSelector(
  [
    $getSelectedOffer,
    $getOrderTotals,
    $getStagedPurchaseCount,
    $getStagedPurchases,
    getChoiceOrderingMethod,
  ],
  get,
);
